import { render, staticRenderFns } from "./BtnScrollDown.vue?vue&type=template&id=b7525a10&"
import script from "./BtnScrollDown.vue?vue&type=script&lang=js&"
export * from "./BtnScrollDown.vue?vue&type=script&lang=js&"
import style0 from "./BtnScrollDown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports